
import { BaseService } from "../BaseService";
import { NoseurObject } from "@ronuse/noseur";
import { ISupportCategory } from "./SupportCategoryService";
import { i18nManager } from "../../i18n";

export enum IStatus {
    ACTIVE = "ACTIVE",
    OPENED = "OPENED",
    CLOSED = "CLOSED",
    DELETED = "DELETED",
    STALLED = "STALLED",
    RESOLVED = "RESOLVED",
    RE_OPENED = "RE_OPENED",
    UNRESOLVED = "UNRESOLVED",
}

export interface IUser {
    last_name: string;
    first_name: string;
    updated_at: string;
    created_at: string;
    middle_name: string;
    external_id: string;
    profile_picture_location: string;
}

export interface ISupportRequest {
    user: IUser;
    title: string;
    status: IStatus;
    created_at: string;
    external_id: string;
    participants: IUser[];
    category: ISupportCategory;
}

export class SupportRequestService extends BaseService {

    protected static instance: SupportRequestService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!SupportRequestService.instance) SupportRequestService.instance = new SupportRequestService();
        return SupportRequestService.instance;
    }

    static getStatusLabel(status: IStatus) {
        let lowercaseValue = (status.toLowerCase());
        return (i18nManager.Labels.support.ticket.tickets.status_map as any)[`${lowercaseValue}`] ?? lowercaseValue;
    }

    querySupportRequests(query: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<any> {
        return this.report(this.transport.get("/hera/api/v1/support/request", { query: this.normalizeParams(query) }));
    }

    getSingleSupportRequest(id: string): Promise<any> {
        return this.report(this.transport.get(`/hera/api/v1/support/request/${id}`));
    }

    countOpenedSupportTicket(platformId: string): Promise<any> {
        return this.report(this.transport.get(`/hera/api/v1/support/request/count`, { query: { "platform.external_id": platformId }}));
    }

    createSupportTicket(payload: NoseurObject<any>): Promise<any> {
        return this.report(this.transport.post(`/hera/api/v1/support/request`, payload));
    }

    updateSupportTicketStatus(id: string, status: IStatus): Promise<any> {
        return this.report(this.transport.patch(`/hera/api/v1/support/request/${id}/status`, { status }));
    }

}
